import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React from 'react';
import { useSelector } from 'react-redux';

import ReportModel from './ExpressionModal/ReportModel';
import { MODEL_PICKER_MODAL_STYLES } from '../../constants/CommonStylesConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getReportInfo } from '../selectors/report-designer.selectors';

const useStyles = makeStyles({
  modal: MODEL_PICKER_MODAL_STYLES,
});

const ReportModelPickerModal = ({ open, onClose, onChange }) => {
  const translateString = useTranslation();
  const classes = useStyles();

  const { reportModelName } = useSelector(getReportInfo);

  const buttonsList = [
    {
      label: translateString('Cancel'),
      onClick: onClose,
    },
  ];

  return (
    <Modal
      open={open}
      variant="default"
      onClose={onClose}
      title={`${translateString('Report Model')} (${reportModelName})`}
      classes={{
        paper: classes.modal,
      }}
      buttonProps={buttonsList}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <ReportModel change={onChange} singleSelect showSearch />
    </Modal>
  );
};

export default ReportModelPickerModal;
